import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './index.css';
import { IoClose } from 'react-icons/io5';

import homevideo from '../../assests/homevideokara.mp4';
import homeicon from '../../assests/karaicon.svg'; 
import homesection2bg from '../../assests/homesection2bg.png';

import Footer from '../Footer';

const Home = () => {
  const videoRef = useRef(null);
  const navigate = useNavigate();
  const [activeService, setActiveService] = useState(0);
  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isConceptOpen, setIsConceptOpen] = useState(false);

  const toggleConceptMenu = () => {
    setIsConceptOpen(!isConceptOpen);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Ensure video plays continuously
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(error => {
        console.log("Video autoplay failed:", error);
      });
    }
  }, []);

  const services = [
    "Bespoke Product Design & Development",
    "Limited-Edition Luxury Collections",
    "Material Sourcing & Traceability Consulting",
    "High-End Manufacturing & Artisan Partnerships",
    "Sustainable & Circular Design Solutions",
    "Luxury Packaging & Unboxing Experience",
    "High-Touch Concierge & Private Client Services",
    "Boutique Hotel & Luxury Hospitality Solutions",
    "Curated Art & Interior Styling"
  ];

  const serviceIdMap = {
    0: 'bespoke-product-design',
    1: 'limited-edition-collections',
    2: 'material-sourcing',
    3: 'high-end-manufacturing',
    4: 'sustainable-design',
    5: 'luxury-packaging',
    6: 'concierge-services',
    7: 'hospitality-solutions',
    8: 'art-interior-styling'
  };

  const handleServiceClick = (index) => {
    setActiveService(index);
    const serviceId = serviceIdMap[index];
    navigate(`/services#${serviceId}`);
  };

  const testimonials = [
    {
      id: 1,
      name: "Aarav & Meera Jain",
      subtitle: "Private Residence - Hyderabad",
      text: "Working with Kara felt like collaborating with artists who truly listened. They didn't just design furniture—they solved our spatial challenges with grace, beauty, and thoughtful function. Every piece feels like it belongs only to us."
    },
    {
      id: 2,
      name: "Shreya Kapoor",
      subtitle: "Boutique Hotel Owner",
      text: "Kara's work goes beyond aesthetics—it's intelligent, intentional, and incredibly refined. Their ability to translate our vision into handcrafted, one-of-one pieces made the experience deeply personal and unforgettable."
    },
    {
      id: 3,
      name: "Rajesh Malhotra",
      subtitle: "Corporate Office - Mumbai",
      text: "The attention to detail and commitment to sustainability impressed us deeply. Kara transformed our workspace into an environment that inspires creativity and reflects our values perfectly."
    },
    {
      id: 4,
      name: "Priya Sharma",
      subtitle: "Luxury Villa - Goa",
      text: "From concept to completion, Kara's team demonstrated exceptional craftsmanship and design sensibility. Each piece tells a story and adds character to our home in ways we never imagined possible."
    }
  ];

  const handleNextTestimonial = () => {
    if (currentTestimonialIndex < testimonials.length - 1) {
      setCurrentTestimonialIndex(prev => prev + 1);
    }
  };

  const handlePrevTestimonial = () => {
    if (currentTestimonialIndex > 0) {
      setCurrentTestimonialIndex(prev => prev - 1);
    }
  };

  const getVisibleTestimonials = () => {
    return testimonials.slice(currentTestimonialIndex, currentTestimonialIndex + 2);
  };

  return (
    <>
      {/* SECTION 1: Full Screen Video Background with Navigation */}
      <section className="home-section">
        <video 
          ref={videoRef}
          className="home-background-video" 
          autoPlay 
          loop 
          muted 
          playsInline
        >
          <source src={homevideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div className="home-overlay"></div>

        <div className="home-content-wrapper">
          <div className="home-logo">
            <Link to="/">
              <img src={homeicon} alt="Kara Icon" className="home-icon" />
            </Link>
          </div>

          <nav className="home-navigation">
            <ul className="home-nav-list">
              <li><Link to="/about">About US</Link></li>
              <li><Link to="/process">Our Process</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/collections">Collections & Products</Link></li>
              {/* <li className="nav-item-with-submenu">
                  <span className="nav-concept-trigger" onClick={toggleConceptMenu}>
                    Concept <span className="dropdown-arrow">▼</span>
                  </span>
                  {isConceptOpen && (
                    <ul className="concept-submenu">
                      <li><Link to="/concept-1">Concept-1</Link></li>
                      <li><Link to="/concept-2">Concept-2</Link></li>
                    </ul>
                  )}
              </li> */}
              <li><Link to="/sustainability">Sustainability & Ethical Sourcing</Link></li>
              <li><Link to="/private-client">Private Client Services</Link></li>
              {/* <li><Link to="/hospitality">Hospitality & Commercial Solutions</Link></li>
              <li><Link to="/journal">Journal / Blog</Link></li>  */}
              <li><Link to="/concept" onClick={toggleMenu}>concept</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </nav>
        </div>
      </section>

      {/* ✅ STICKY NAVBAR - BETWEEN SECTIONS */}
      <nav className="home-about-navbar">
        <div className="home-about-navbar-logo">
          <Link to="/">
            <img src={homeicon} alt="Kara Logo" className="home-about-logo-icon" />
          </Link>
        </div>
        <div className="home-about-navbar-menu" onClick={toggleMenu}>
          <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none" className="home-about-hamburger-icon">
            <circle cx="24.5" cy="24.5" r="24" fill="black" stroke="#9A9A9A"/>
            <rect x="13" y="16" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
            <rect x="13" y="23" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
            <rect x="13" y="30" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
          </svg>
        </div>
      </nav>

      {/* ✅ NAVIGATION MENU OVERLAY */}
      {isMenuOpen && (
        <div className="home-about-nav-overlay">
          <div className="home-about-nav-close" onClick={toggleMenu}>
            <IoClose className="home-about-close-icon" />
          </div>
          <nav className="home-about-navigation">
            <ul className="home-about-nav-list">
              <li><Link to="/about" onClick={toggleMenu}>About US</Link></li>
              <li><Link to="/process" onClick={toggleMenu}>Our Process</Link></li>
              <li><Link to="/services" onClick={toggleMenu}>Services</Link></li>
              <li><Link to="/collections" onClick={toggleMenu}>Collections & Products</Link></li>
              
              <li><Link to="/sustainability" onClick={toggleMenu}>Sustainability & Ethical Sourcing</Link></li>
              <li><Link to="/private-client" onClick={toggleMenu}>Private Client Services</Link></li>
              {/* <li><Link to="/hospitality" onClick={toggleMenu}>Hospitality & Commercial Solutions</Link></li>
              <li><Link to="/journal" onClick={toggleMenu}>Journal / Blog</Link></li> */}
              {/* <li className="nav-item-with-submenu">
                  <span className="nav-concept-trigger" onClick={toggleConceptMenu}>
                    Concept <span className="dropdown-arrow">▼</span>
                  </span>
                  {isConceptOpen && (
                    <ul className="concept-submenu">
                      <li><Link to="/concept-1" onClick={toggleMenu}>Concept-1</Link></li>
                      <li><Link to="/concept-2" onClick={toggleMenu}>Concept-2</Link></li>
                    </ul>
                  )}
              </li> */}
              <li><Link to="/concept-1" onClick={toggleMenu}>concept</Link></li>
              <li><Link to="/contact" onClick={toggleMenu}>Contact Us</Link></li>
            </ul>
          </nav>
        </div>
      )}

      {/* SECTION 2: Background Image with Text Content */}
      <section className="home-section-2">
        <div className="home-section-2-background">
          <img src={homesection2bg} alt="Background" className="home-section-2-bg-image" />
        </div>

        <div className="home-section-2-overlay"></div>

        <div className="home-section-2-content">
          <div className="home-section-2-title">
            <h2>We don't just design products—we design purpose into every piece.</h2>
          </div>

          <div className="home-section-2-description">
            <p>
              Rooted in the philosophy of thoughtful innovation, Kara crafts bespoke design 
              solutions that respond to the real challenges of modern interiors. Our work reflects 
              a deep commitment to function, beauty, and sustainability—crafted to inspire and 
              built to last.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 3: Crafted Stories Section */}
      <section className="home-section-3">
        <div className="home-section-3-header">
            <h2 className="home-section-3-title">Crafted Stories, Curated Solutions</h2>
            <p className="home-section-3-subtitle">
            Explore our design journey—from identifying unique client needs to crafting 
            exclusive, handcrafted pieces with meaningful purpose.
            </p>
        </div>

        <div className="home-section-3-gallery">
            <div className="home-section-3-image-wrapper">
              <img 
                  src={require('../../assests/section3-image1.jpg')} 
                  alt="Crafted Furniture 1" 
                  className="home-section-3-image" 
              />
            </div>
            <div className="home-section-3-image-wrapper">
            <img 
                src={require('../../assests/section3-image2.jpg')} 
                alt="Crafted Furniture 2" 
                className="home-section-3-image" 
            />
            </div>
            <div className="home-section-3-image-wrapper">
            <img 
                src={require('../../assests/section3-image3.png')} 
                alt="Crafted Furniture 3" 
                className="home-section-3-image" 
            />
            </div>
        </div>

        <Link to="/collections">
          <button className="home-section-3-button">
            <span className="home-section-3-button-text">View Collection</span>
          </button>
        </Link>
      </section>
    
      {/* SECTION 4: Custom-Designed Services */}
      <section className="home-section-4">
        <div className="home-section-4-content">
          <div className="home-section-4-header">
            <h2 className="home-section-4-title">Custom-Designed for the Exceptional</h2>
            <p className="home-section-4-subtitle">
              Kara offers handcrafted luxury design solutions—each a response to individual 
              spatial and aesthetic challenges.
            </p>
          </div>

          <nav className="home-section-4-services">
            <ul className="home-section-4-services-list">
              {services.map((service, index) => (
                <li 
                  key={index}
                  className={`home-section-4-service-item ${activeService === index ? 'active' : ''}`}
                  onClick={() => handleServiceClick(index)}
                  onMouseEnter={() => setActiveService(index)}
                  style={{ cursor: 'pointer' }}
                >
                  <span className="home-section-4-service-text">{service}</span>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </section>  

      {/* SECTION 5: Trusted by Connoisseurs of Craft - CAROUSEL */}
      <section className="home-section-5">
        <h1 className='section5-heading-text-trustedby'>Trusted by Connoisseurs of Craft</h1>
        <p className='section5-para-text-hearfromclients'>
          Hear from clients who've experienced design solutions that are as thoughtful as they are timeless.
        </p>
        
        <div className="home-section-5-carousel-wrapper">
          <div className="home-section-5-testimonials-container">
            {getVisibleTestimonials().map((testimonial) => (
              <div 
                key={testimonial.id} 
                className="home-section-5-testimonial-card"
              >
                <h1 className="home-section-5-testimonial-card-heading">
                  {testimonial.name}
                </h1>
                <h2 className="home-section-5-testimonial-card-subheading">
                  {testimonial.subtitle}
                </h2>
                <p className="home-section-5-testimonial-card-text">
                  {testimonial.text}
                </p>
              </div>
            ))}
          </div>
        </div>

        <button className="arrow-button">
          <span
            className={`arrow-icon ${currentTestimonialIndex === 0 ? 'disabled' : ''}`}
            onClick={handlePrevTestimonial}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="18" viewBox="0 0 9 18" fill="none">
              <path
                d="M7.16101 13.0648L6.36526 13.8598L2.03101 9.52707C1.96114 9.45765 1.9057 9.37509 1.86786 9.28415C1.83002 9.19322 1.81055 9.09569 1.81055 8.9972C1.81055 8.8987 1.83002 8.80118 1.86786 8.71025C1.9057 8.61931 1.96114 8.53675 2.03101 8.46733L6.36526 4.13233L7.16026 4.92733L3.09226 8.99607L7.16101 13.0648Z"
                fill={currentTestimonialIndex === 0 ? "#3D3D3D" : "#7D7D7D"}
              />
            </svg>
          </span>

          <span
            className={`arrow-icon ${currentTestimonialIndex >= testimonials.length - 1 ? 'disabled' : ''}`}
            onClick={handleNextTestimonial}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="18" viewBox="0 0 9 18" fill="none">
              <path
                d="M1.83899 4.93518L2.63474 4.14018L6.96899 8.47293C7.03886 8.54235 7.0943 8.62491 7.13214 8.71585C7.16997 8.80678 7.18945 8.90431 7.18945 9.0028C7.18945 9.1013 7.16997 9.19882 7.13214 9.28976C7.0943 9.38069 7.03886 9.46325 6.96899 9.53268L2.63474 13.8677L1.83974 13.0727L5.90774 9.00393L1.83899 4.93518Z"
                fill={currentTestimonialIndex >= testimonials.length - 1 ? "#3D3D3D" : "#FFFFFF"}
              />
            </svg>
          </span>
        </button>

      </section>

      {/* SECTION 6: Let's Co-Create Something*/}
      <section className='home-section-6'> 
        <h1 className='section6-heading-text'>Let's Co-Create Something Exceptional</h1>
        <p className='section6-para-text'>Reach out for a personalized consultation and begin your bespoke design journey with Kara.</p>
        <Link to="/contact">
          <button className='section6-contact-button'>Book a Private Consultation</button>
        </Link>
      </section>
      
      <Footer />  
    </>
  );
};

export default Home;